import {Component, Input} from '@angular/core';
import {IndicationBasicModel} from '@core/modules/rest/indication/response/indication-basic.model';

@Component({
  selector: 'app-indication-list',
  templateUrl: './indication-list.component.html',
  styleUrls: ['./indication-list.component.scss']
})
export class IndicationListComponent{

  @Input() indications!: IndicationBasicModel[];
}
